const Ziggy = {
  url: import.meta.env.VITE_APP_URL || 'http://localhost',
  port: undefined,
  defaults: {},
  routes: {
    'api.v1.company.projects.store': {
      uri: 'api/v1/companies/{company}/projects',
      methods: ['POST'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.company.projects.destroy': {
      uri: 'api/v1/companies/{company}/projects/{project}',
      methods: ['DELETE'],
      parameters: ['company', 'project'],
      bindings: { company: 'id', project: 'id' },
    },

    'api.v1.companies.user-roles.attach': {
      uri: 'api/v1/companies/{company}/projects/{project}/users',
      methods: ['POST'],
      parameters: ['company', 'project'],
      bindings: { company: 'id', project: 'id' },
    },

    'api.v1.companies.user-roles.detach': {
      uri: 'api/v1/companies/{company}/projects/{project}/users',
      methods: ['DELETE'],
      parameters: ['company', 'project'],
      bindings: { company: 'id', project: 'id' },
    },

    'api.v1.companies.users.index': {
      uri: 'api/v1/companies/{company}/users',
      methods: ['GET', 'HEAD'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.company.project-supplier.store': {
      uri: 'api/v1/companies/{company}/project-supplier',
      methods: ['POST'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.company.project-supplier.clone': {
      uri: 'api/v1/companies/{company}/project-suppliers/clone',
      methods: ['POST'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.companies.logo.store': {
      uri: 'api/v1/companies/{company}/logo',
      methods: ['POST'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.companies.logo.show': {
      uri: 'api/v1/companies/{company}/logo/{project?}',
      methods: ['GET', 'HEAD'],
      parameters: ['company', 'project'],
      bindings: { company: 'id', project: 'id' },
    },

    'api.v1.companies.users.store': {
      uri: 'api/v1/companies/{company}/users',
      methods: ['POST'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.companies.users.search': {
      uri: 'api/v1/companies/{company}/users/search',
      methods: ['GET', 'HEAD'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.companies.project-groups.index': {
      uri: 'api/v1/companies/{company}/project-groups',
      methods: ['GET', 'HEAD'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.companies.project-groups.store': {
      uri: 'api/v1/companies/{company}/project-groups',
      methods: ['POST'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.company.project-supplier.update': {
      uri: 'api/v1/companies/project-supplier/{project_supplier}',
      methods: ['PUT', 'PATCH'],
      parameters: ['project_supplier'],
      bindings: { project_supplier: 'id' },
    },

    'api.v1.company.project-supplier.destroy': {
      uri: 'api/v1/companies/project-supplier/{project_supplier}',
      methods: ['DELETE'],
      parameters: ['project_supplier'],
      bindings: { project_supplier: 'id' },
    },

    'api.v1.projects.wbs_code.average': {
      uri: 'api/v1/projects/{project}/average',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.plant-utilisation': {
      uri: 'api/v1/projects/{project}/plant-utilisation',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.search': { uri: 'api/v1/projects/search', methods: ['GET', 'HEAD'] },
    'api.v1.projects.index': { uri: 'api/v1/projects', methods: ['GET', 'HEAD'] },
    'api.v1.projects.store': { uri: 'api/v1/projects', methods: ['POST'] },
    'api.v1.projects.show': {
      uri: 'api/v1/projects/{project}',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.update': {
      uri: 'api/v1/projects/{project}',
      methods: ['PUT', 'PATCH'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.destroy': {
      uri: 'api/v1/projects/{project}',
      methods: ['DELETE'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.lock-boq': {
      uri: 'api/v1/projects/{project}/lock-boq',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.unlock-boq': {
      uri: 'api/v1/projects/{project}/unlock-boq',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.labours.daily': {
      uri: 'api/v1/daily/labour/{project}',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.labours.show': {
      uri: 'api/v1/labours/{labour}',
      methods: ['GET', 'HEAD'],
      parameters: ['labour'],
      bindings: { labour: 'id' },
    },

    'api.v1.labours.update': {
      uri: 'api/v1/labours/{labour}',
      methods: ['PUT', 'PATCH'],
      parameters: ['labour'],
      bindings: { labour: 'id' },
    },

    'api.v1.labours.destroy': {
      uri: 'api/v1/labours/{labour}',
      methods: ['DELETE'],
      parameters: ['labour'],
      bindings: { labour: 'id' },
    },

    'api.v1.plants.hire': {
      uri: 'api/v1/plants/{plant}/hire',
      methods: ['PATCH'],
      parameters: ['plant'],
      bindings: { plant: 'id' },
    },

    'api.v1.plants.daily': {
      uri: 'api/v1/daily/plant/{project}',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plants.show': {
      uri: 'api/v1/plants/{plant}',
      methods: ['GET', 'HEAD'],
      parameters: ['plant'],
      bindings: { plant: 'id' },
    },

    'api.v1.plants.update': {
      uri: 'api/v1/plants/{plant}',
      methods: ['PUT', 'PATCH'],
      parameters: ['plant'],
      bindings: { plant: 'id' },
    },

    'api.v1.plants.destroy': {
      uri: 'api/v1/plants/{plant}',
      methods: ['DELETE'],
      parameters: ['plant'],
      bindings: { plant: 'id' },
    },

    'api.v1.labours.index': {
      uri: 'api/v1/{project}/labours',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.labours.store': {
      uri: 'api/v1/{project}/labours',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plants.index': {
      uri: 'api/v1/{project}/plants',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plants.store': {
      uri: 'api/v1/{project}/plants',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plant.daily.records.approve': {
      uri: 'api/v1/records/plant/{record}/approve',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.unapprove': {
      uri: 'api/v1/records/plant/{record}/unapprove',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.paid': {
      uri: 'api/v1/records/plant/{record}/paid',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.split': {
      uri: 'api/v1/records/plant/{record}/split',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.comments': {
      uri: 'api/v1/records/plant/{record}/comments',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.vendor': {
      uri: 'api/v1/records/plant/{record}/vendor',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.show': {
      uri: 'api/v1/records/plant/records/{record}',
      methods: ['GET', 'HEAD'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.update': {
      uri: 'api/v1/records/plant/records/{record}',
      methods: ['PUT', 'PATCH'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.destroy': {
      uri: 'api/v1/records/plant/records/{record}',
      methods: ['DELETE'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.plant.daily.records.index': {
      uri: 'api/v1/records/plant/{plant}/records',
      methods: ['GET', 'HEAD'],
      parameters: ['plant'],
      bindings: { plant: 'id' },
    },

    'api.v1.plant.daily.records.store': {
      uri: 'api/v1/records/plant/{plant}/records',
      methods: ['POST'],
      parameters: ['plant'],
      bindings: { plant: 'id' },
    },

    'api.v1.labour.daily.records.approve': {
      uri: 'api/v1/records/labour/{record}/approve',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.unapprove': {
      uri: 'api/v1/records/labour/{record}/unapprove',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.paid': {
      uri: 'api/v1/records/labour/{record}/paid',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.split': {
      uri: 'api/v1/records/labour/{record}/split',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.comments': {
      uri: 'api/v1/records/labour/{record}/comments',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.vendor': {
      uri: 'api/v1/records/labour/{record}/vendor',
      methods: ['POST'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.show': {
      uri: 'api/v1/records/labour/records/{record}',
      methods: ['GET', 'HEAD'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.update': {
      uri: 'api/v1/records/labour/records/{record}',
      methods: ['PUT', 'PATCH'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.destroy': {
      uri: 'api/v1/records/labour/records/{record}',
      methods: ['DELETE'],
      parameters: ['record'],
      bindings: { record: 'id' },
    },

    'api.v1.labour.daily.records.index': {
      uri: 'api/v1/records/labour/{labour}/records',
      methods: ['GET', 'HEAD'],
      parameters: ['labour'],
      bindings: { labour: 'id' },
    },

    'api.v1.labour.daily.records.store': {
      uri: 'api/v1/records/labour/{labour}/records',
      methods: ['POST'],
      parameters: ['labour'],
      bindings: { labour: 'id' },
    },

    'api.v1.users.signature.show': { uri: 'api/v1/users/signature', methods: ['GET', 'HEAD'] },
    'api.v1.users.signature.store': { uri: 'api/v1/users/signature', methods: ['POST'] },
    'api.v1.users.tokens.index': { uri: 'api/v1/users/tokens', methods: ['GET', 'HEAD'] },
    'api.v1.users.tokens.store': { uri: 'api/v1/users/tokens', methods: ['POST'] },
    'api.v1.users.tokens.destroy': { uri: 'api/v1/users/tokens/{token}', methods: ['DELETE'], parameters: ['token'] },
    'api.v1.users.index': { uri: 'api/v1/users', methods: ['GET', 'HEAD'] },
    'api.v1.users.store': { uri: 'api/v1/users', methods: ['POST'] },
    'api.v1.users.show': {
      uri: 'api/v1/users/{user}',
      methods: ['GET', 'HEAD'],
      parameters: ['user'],
      bindings: { user: 'id' },
    },

    'api.v1.users.update': {
      uri: 'api/v1/users/{user}',
      methods: ['PUT', 'PATCH'],
      parameters: ['user'],
      bindings: { user: 'id' },
    },

    'api.v1.users.destroy': {
      uri: 'api/v1/users/{user}',
      methods: ['DELETE'],
      parameters: ['user'],
      bindings: { user: 'id' },
    },

    'api.v1.users.update-me': { uri: 'api/v1/users/update/me', methods: ['PATCH'] },
    'api.v1.users.toggle-disable': {
      uri: 'api/v1/users/{user}/toggle-disable',
      methods: ['POST'],
      parameters: ['user'],
      bindings: { user: 'id' },
    },

    'api.v1.roles.index': { uri: 'api/v1/roles', methods: ['GET', 'HEAD'] },
    'api.v1.notifications.index': { uri: 'api/v1/notifications', methods: ['GET', 'HEAD'] },
    'api.v1.notifications.mark-all-read': { uri: 'api/v1/notifications/mark-all-read', methods: ['POST'] },
    'api.v1.notifications.destroy': {
      uri: 'api/v1/notifications/{notification}',
      methods: ['DELETE'],
      parameters: ['notification'],
      bindings: { notification: 'id' },
    },

    'api.v1.notifications.destroy-all': { uri: 'api/v1/notifications', methods: ['DELETE'] },
    'api.v1.report-sections.index': {
      uri: 'api/v1/project/{project}/report-sections',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.subcontractor.claims.store': {
      uri: 'api/v1/project/{project}/subcontractor/{project_supplier}/claims',
      methods: ['POST'],
      parameters: ['project', 'project_supplier'],
      bindings: { project: 'id', project_supplier: 'id' },
    },

    'api.v1.subcontractor.claims.dashboard.index': {
      uri: 'api/v1/project/{project}/subcontractor/dashboard',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.subcontractor.claims.dashboard.show': {
      uri: 'api/v1/project/{project}/subcontractor/dashboard/{package}',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.subcontractor.claims.summary': {
      uri: 'api/v1/project/{project}/subcontractor/claims/summary/{claim}',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.show': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.issue': {
      uri: 'api/v1/project/{project}/subcontractor/{claim}/issue',
      methods: ['POST'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.issue-certificate': {
      uri: 'api/v1/project/{project}/subcontractor/{claim}/issue-certificate',
      methods: ['POST'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.export': {
      uri: 'api/v1/project/{project}/subcontractor/{claim}/export',
      methods: ['POST'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.certify': {
      uri: 'api/v1/project/{project}/subcontractor/{claim}/certify',
      methods: ['POST'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.uncertify': {
      uri: 'api/v1/project/{project}/subcontractor/{claim}/uncertify',
      methods: ['POST'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.rates.certified.store': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/rates/{rates_cost}/certified',
      methods: ['POST'],
      parameters: ['project', 'claim', 'rates_cost'],
      bindings: { project: 'id', claim: 'id', rates_cost: 'id' },
    },

    'api.v1.subcontractor.claims.lump-sum.certified.store': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/lump-sum/{lump_sum_cost}/certified',
      methods: ['POST'],
      parameters: ['project', 'claim', 'lump_sum_cost'],
      bindings: { project: 'id', claim: 'id', lump_sum_cost: 'id' },
    },

    'api.v1.subcontractor.claims.mass-send': {
      uri: 'api/v1/project/{project}/subcontractor/claims/mass-send',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.subcontractor.claims.variation.certified.store': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/variation-order/{variation_order_cost}/certified',
      methods: ['POST'],
      parameters: ['project', 'claim', 'variation_order_cost'],
      bindings: { project: 'id', claim: 'id', variation_order_cost: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.certified.store': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/dayworks/{dayworks_cost}/certified',
      methods: ['POST'],
      parameters: ['project', 'claim', 'dayworks_cost'],
      bindings: { project: 'id', claim: 'id', dayworks_cost: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.labour.index': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/dayworks/labour',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.labour.records': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/dayworks/labour/{labour}/records',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'claim', 'labour'],
      bindings: { project: 'id', claim: 'id', labour: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.plant.index': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/dayworks/plant',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.plant.records': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/dayworks/plant/{plant}/records',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'claim', 'plant'],
      bindings: { project: 'id', claim: 'id', plant: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.export': {
      uri: 'api/v1/project/{project}/subcontractor/claims/{claim}/dayworks/export',
      methods: ['POST'],
      parameters: ['project', 'claim'],
      bindings: { project: 'id', claim: 'id' },
    },

    'api.v1.projects.commentary.index': {
      uri: 'api/v1/project/{project}/commentary',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.commentary.store': {
      uri: 'api/v1/project/{project}/commentary',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.commentary.show': {
      uri: 'api/v1/project/{project}/commentary/{commentary}',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'commentary'],
      bindings: { project: 'id', commentary: 'id' },
    },

    'api.v1.projects.commentary.update': {
      uri: 'api/v1/project/{project}/commentary/{commentary}',
      methods: ['PUT', 'PATCH'],
      parameters: ['project', 'commentary'],
      bindings: { project: 'id', commentary: 'id' },
    },

    'api.v1.reports.index': {
      uri: 'api/v1/project/{project}/reports',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.reports.store': {
      uri: 'api/v1/project/{project}/reports',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.activity-log': {
      uri: 'api/v1/project/{project}/activity-log',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.archive': {
      uri: 'api/v1/project/{project}/archive',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.unarchive': {
      uri: 'api/v1/project/{project}/unarchive',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.wbs-codes.index': {
      uri: 'api/v1/project/{project}/wbs-codes',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.wbs-codes.store': {
      uri: 'api/v1/project/{project}/wbs-codes',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-orders.index': {
      uri: 'api/v1/project/{project}/variation-orders',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-orders.store': {
      uri: 'api/v1/project/{project}/variation-orders',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-orders.transfer': {
      uri: 'api/v1/project/{project}/variation-orders/{variation_order}/transfer',
      methods: ['POST'],
      parameters: ['project', 'variation_order'],
      bindings: { project: 'id', variation_order: 'id' },
    },

    'api.v1.shared-fund.claim-index': {
      uri: 'api/v1/project/{project}/shared-fund/claim-index',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-order-categories.index': {
      uri: 'api/v1/project/{project}/variation-order-categories',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-order-categories.store': {
      uri: 'api/v1/project/{project}/variation-order-categories',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.query': {
      uri: 'api/v1/project/{project}/quantities/query',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.forecast': {
      uri: 'api/v1/project/{project}/quantities/forecast',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.to-complete': {
      uri: 'api/v1/project/{project}/quantities/to-complete',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.index': {
      uri: 'api/v1/project/{project}/quantities',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.store': {
      uri: 'api/v1/project/{project}/quantities',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.surveyed.index': {
      uri: 'api/v1/project/{project}/quantities/surveyed',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.surveyed.store': {
      uri: 'api/v1/project/{project}/quantities/surveyed',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.project-supplier.index': {
      uri: 'api/v1/project/{project}/project-supplier',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.project-supplier.store': {
      uri: 'api/v1/project/{project}/project-supplier',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.asset-type.store': {
      uri: 'api/v1/project/{project}/asset-type',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plant-categories.store': {
      uri: 'api/v1/project/{project}/plant-categories',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plant-categories.search': {
      uri: 'api/v1/project/{project}/plant-categories/search',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.trade-items.index': {
      uri: 'api/v1/project/{project}/trade-items',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.trade-items.store': {
      uri: 'api/v1/project/{project}/trade-items',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.claims.index': {
      uri: 'api/v1/project/{project}/claims',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.claims.store': {
      uri: 'api/v1/project/{project}/claims',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.diary-entries.index': {
      uri: 'api/v1/project/{project}/diary-entries',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.diary-entries.store': {
      uri: 'api/v1/project/{project}/diary-entries',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.delays.index': {
      uri: 'api/v1/project/{project}/delays',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.delays.store': {
      uri: 'api/v1/project/{project}/delays',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.contract-events.index': {
      uri: 'api/v1/project/{project}/contract-events',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.contract-events.store': {
      uri: 'api/v1/project/{project}/contract-events',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.purchase-orders.index': {
      uri: 'api/v1/project/{project}/purchase-orders',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.purchase-orders.store': {
      uri: 'api/v1/project/{project}/purchase-orders',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.diary-entries.users.search': {
      uri: 'api/v1/project/{project}/diary-entries/search',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.labour.daily.records.search': {
      uri: 'api/v1/project/{project}/records/labour/search',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.plant.daily.records.search': {
      uri: 'api/v1/project/{project}/records/plant/search',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.trades.index': {
      uri: 'api/v1/project/{project}/trades',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.trades.store': {
      uri: 'api/v1/project/{project}/trades',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.trades.seed': {
      uri: 'api/v1/project/{project}/trades/seed',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.plant-utilisation-metrics': {
      uri: 'api/v1/project/{project}/plant-utilisation-metrics',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.self-perform-metrics': {
      uri: 'api/v1/project/{project}/self-perform-metrics',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.weekly-performance-metrics': {
      uri: 'api/v1/project/{project}/weekly-performance-metrics',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.head-contract-settings': {
      uri: 'api/v1/project/{project}/head-contract-settings',
      methods: ['PATCH'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.subcontract-settings': {
      uri: 'api/v1/project/{project}/subcontract-settings',
      methods: ['PATCH'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-orders.claim-index': {
      uri: 'api/v1/project/{project}/variation-orders/claim-index',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-orders.summary': {
      uri: 'api/v1/project/{project}/variation-orders/summary',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.variation-orders.summary-report': {
      uri: 'api/v1/project/{project}/variation-orders/summary-report',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.subcontract-variation-orders-dashboard.index': {
      uri: 'api/v1/project/{project}/subcontract-variation-orders-dashboard',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.package-variation-orders.index': {
      uri: 'api/v1/project/{project}/package-variation-orders',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.delays.summary': {
      uri: 'api/v1/project/{project}/delays/summary',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.cover-page.store': {
      uri: 'api/v1/project/{project}/cover-page',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.cover-page.show': {
      uri: 'api/v1/project/{project}/cover-page',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.documents.store': {
      uri: 'api/v1/project/{project}/documents',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.documents.show': {
      uri: 'api/v1/project/{project}/documents',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.monthly-report': {
      uri: 'api/v1/project/{project}/monthly-reports',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.monthly-reports.index': {
      uri: 'api/v1/project/{project}/monthly-reports',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.export-retention-release': {
      uri: 'api/v1/project/{project}/export-retention-release',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.export-final-account': {
      uri: 'api/v1/project/{project}/export-final-account',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.cost-aggregation': {
      uri: 'api/v1/project/{project}/cost-aggregation',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.users.search': {
      uri: 'api/v1/project/{project}/search',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.packages.navbar.index': {
      uri: 'api/v1/project/{project}/packages/navbar',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.packages.index': {
      uri: 'api/v1/project/{project}/packages',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.packages.store': {
      uri: 'api/v1/project/{project}/packages',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.package-trade-items.store': {
      uri: 'api/v1/project/{project}/packages/{package}/package-trade-items',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.procurement-steps.index': {
      uri: 'api/v1/project/{project}/packages/{package}/procurement-steps',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.procurement-steps.update': {
      uri: 'api/v1/project/{project}/packages/{package}/procurement-steps',
      methods: ['PUT'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.tenders.index': {
      uri: 'api/v1/project/{project}/packages/{package}/tenders',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.tenders.issue': {
      uri: 'api/v1/project/{project}/packages/{package}/tenders/issue',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.tenders.select-winner': {
      uri: 'api/v1/project/{project}/packages/{package}/tenders/select-winner',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },


    'api.v1.packages.tenders.export': {
      uri: 'api/v1/project/{project}/packages/{package}/tenders/export',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.variation-orders.index': {
      uri: 'api/v1/project/{project}/packages/{package}/variation-orders',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.variation-orders.store': {
      uri: 'api/v1/project/{project}/packages/{package}/variation-orders',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.variation-orders.back-charge': {
      uri: 'api/v1/project/{project}/packages/{package}/variation-orders/{variation_order}/back-charge',
      methods: ['POST'],
      parameters: ['project', 'package', 'variation_order'],
      bindings: { project: 'id', package: 'id', variation_order: 'id' },
    },

    'api.v1.packages.approved-variations.index': {
      uri: 'api/v1/project/{project}/packages/{package}/approved-variations',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.scope-gaps.store': {
      uri: 'api/v1/project/{project}/packages/{package}/scope-gaps',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.scope-gap-items.store': {
      uri: 'api/v1/project/{project}/packages/{package}/scope-gap-items',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.scope-gap-categories.store': {
      uri: 'api/v1/project/{project}/packages/{package}/scope-gap-categories',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.variation-order-categories.index': {
      uri: 'api/v1/project/{project}/packages/{package}/variation-order-categories',
      methods: ['GET', 'HEAD'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.packages.variation-order-categories.store': {
      uri: 'api/v1/project/{project}/packages/{package}/variation-order-categories',
      methods: ['POST'],
      parameters: ['project', 'package'],
      bindings: { project: 'id', package: 'id' },
    },

    'api.v1.projects.clients.search': {
      uri: 'api/v1/project/{project}/clients/search',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.clients.index': {
      uri: 'api/v1/project/{project}/clients',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.clients.store': {
      uri: 'api/v1/project/{project}/clients',
      methods: ['POST'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.projects.clients.destroy': {
      uri: 'api/v1/project/{project}/clients/{client}',
      methods: ['DELETE'],
      parameters: ['project', 'client'],
      bindings: { project: 'id', client: 'id' },
    },

    'api.v1.projects.client-metrics': {
      uri: 'api/v1/project/{project}/client-metrics',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.subcontractor.claims.lite.certify': {
      uri: 'api/v1/subcontractor/claims/lite/{claim}/certify',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.lite.uncertify': {
      uri: 'api/v1/subcontractor/claims/lite/{claim}/uncertify',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.lite.sopa-disclaimer.update': {
      uri: 'api/v1/subcontractor/claims/lite/{claim}/sopa-disclaimer',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.lite.lump-sum.store': {
      uri: 'api/v1/subcontractor/claims/lite/{claim}/lump-sum/{trade_item}',
      methods: ['POST'],
      parameters: ['claim', 'trade_item'],
      bindings: { claim: 'id', trade_item: 'id' },
    },

    'api.v1.subcontractor.claims.lite.rates.store': {
      uri: 'api/v1/subcontractor/claims/lite/{claim}/rates/{trade_item}',
      methods: ['POST'],
      parameters: ['claim', 'trade_item'],
      bindings: { claim: 'id', trade_item: 'id' },
    },

    'api.v1.subcontractor.claims.lite.dayworks.store': {
      uri: 'api/v1/subcontractor/claims/lite/{claim}/dayworks',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.trade-item-costs.store': {
      uri: 'api/v1/claims/lite/{claim}/trade-items/{trade_item}/certified',
      methods: ['POST'],
      parameters: ['claim', 'trade_item'],
      bindings: { claim: 'id', trade_item: 'id' },
    },

    'api.v1.variation-order-costs.store': {
      uri: 'api/v1/claims/lite/{claim}/variation-orders/{variation_order}/certified',
      methods: ['POST'],
      parameters: ['claim', 'variation_order'],
      bindings: { claim: 'id', variation_order: 'id' },
    },

    'api.v1.shared-fund-costs.store': {
      uri: 'api/v1/claims/lite/{claim}/shared-funds/{shared_fund}/certified',
      methods: ['POST'],
      parameters: ['claim', 'shared_fund'],
      bindings: { claim: 'id', shared_fund: 'id' },
    },

    'api.v1.claims.lite.certify': {
      uri: 'api/v1/claims/lite/{claim}/certify',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.lite.uncertify': {
      uri: 'api/v1/claims/lite/{claim}/uncertify',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.lite.export': {
      uri: 'api/v1/claims/lite/{claim}/export',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.reports.show': {
      uri: 'api/v1/reports/{report}',
      methods: ['GET', 'HEAD'],
      parameters: ['report'],
      bindings: { report: 'id' },
    },

    'api.v1.reports.update': {
      uri: 'api/v1/reports/{report}',
      methods: ['PUT', 'PATCH'],
      parameters: ['report'],
      bindings: { report: 'id' },
    },

    'api.v1.reports.destroy': {
      uri: 'api/v1/reports/{report}',
      methods: ['DELETE'],
      parameters: ['report'],
      bindings: { report: 'id' },
    },

    'api.v1.reports.generate': {
      uri: 'api/v1/reports/{report}/generate',
      methods: ['POST'],
      parameters: ['report'],
      bindings: { report: 'id' },
    },

    'api.v1.reports.issue': {
      uri: 'api/v1/reports/{report}/issue/{media}',
      methods: ['POST'],
      parameters: ['report', 'media'],
      bindings: { report: 'id', media: 'uuid' },
    },

    'api.v1.comments.update': {
      uri: 'api/v1/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['comment'],
      bindings: { comment: 'id' },
    },

    'api.v1.comments.destroy': {
      uri: 'api/v1/comments/{comment}',
      methods: ['DELETE'],
      parameters: ['comment'],
      bindings: { comment: 'id' },
    },

    'api.v1.variation-order-costs.comments.update': {
      uri: 'api/v1/variation-order-costs/{variation_order_cost}/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['variation_order_cost', 'comment'],
      bindings: { variation_order_cost: 'id', comment: 'id' },
    },

    'api.v1.variation-order-costs.comments.destroy': {
      uri: 'api/v1/variation-order-costs/{variation_order_cost}/comments/{comment}',
      methods: ['DELETE'],
      parameters: ['variation_order_cost', 'comment'],
      bindings: { variation_order_cost: 'id', comment: 'id' },
    },

    'api.v1.project-groups.show': {
      uri: 'api/v1/project-groups/{project_group}',
      methods: ['GET', 'HEAD'],
      parameters: ['project_group'],
      bindings: { project_group: 'id' },
    },

    'api.v1.project-groups.update': {
      uri: 'api/v1/project-groups/{project_group}',
      methods: ['PUT', 'PATCH'],
      parameters: ['project_group'],
      bindings: { project_group: 'id' },
    },

    'api.v1.project-groups.destroy': {
      uri: 'api/v1/project-groups/{project_group}',
      methods: ['DELETE'],
      parameters: ['project_group'],
      bindings: { project_group: 'id' },
    },

    'api.v1.project-groups.report': {
      uri: 'api/v1/project-groups/{project_group}/report',
      methods: ['POST'],
      parameters: ['project_group'],
      bindings: { project_group: 'id' },
    },

    'api.v1.project-groups.shared-funds.store': {
      uri: 'api/v1/project-groups/{project_group}/shared-funds',
      methods: ['POST'],
      parameters: ['project_group'],
      bindings: { project_group: 'id' },
    },

    'api.v1.shared-funds.update': {
      uri: 'api/v1/shared-funds/{shared_fund}',
      methods: ['PATCH'],
      parameters: ['shared_fund'],
      bindings: { shared_fund: 'id' },
    },

    'api.v1.shared-funds.destroy': {
      uri: 'api/v1/shared-funds/{shared_fund}',
      methods: ['DELETE'],
      parameters: ['shared_fund'],
      bindings: { shared_fund: 'id' },
    },

    'api.v1.shared-fund-costs.comments.update': {
      uri: 'api/v1/shared-fund-costs/{shared_fund_cost}/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['shared_fund_cost', 'comment'],
      bindings: { shared_fund_cost: 'id', comment: 'id' },
    },

    'api.v1.shared-fund-costs.comments.destroy': {
      uri: 'api/v1/shared-fund-costs/{shared_fund_cost}/comments/{comment}',
      methods: ['DELETE'],
      parameters: ['shared_fund_cost', 'comment'],
      bindings: { shared_fund_cost: 'id', comment: 'id' },
    },

    'api.v1.shared-fund-costs.update': {
      uri: 'api/v1/shared-fund-costs/{shared_fund_cost}',
      methods: ['PUT', 'PATCH'],
      parameters: ['shared_fund_cost'],
      bindings: { shared_fund_cost: 'id' },
    },

    'api.v1.shared-fund-costs.destroy': {
      uri: 'api/v1/shared-fund-costs/{shared_fund_cost}',
      methods: ['DELETE'],
      parameters: ['shared_fund_cost'],
      bindings: { shared_fund_cost: 'id' },
    },

    'api.v1.variation-order-costs.update': {
      uri: 'api/v1/variation-order-costs/{variation_order_cost}',
      methods: ['PUT', 'PATCH'],
      parameters: ['variation_order_cost'],
      bindings: { variation_order_cost: 'id' },
    },

    'api.v1.variation-order-costs.destroy': {
      uri: 'api/v1/variation-order-costs/{variation_order_cost}',
      methods: ['DELETE'],
      parameters: ['variation_order_cost'],
      bindings: { variation_order_cost: 'id' },
    },

    'api.v1.dayworks-costs.update': {
      uri: 'api/v1/dayworks-costs/{dayworks_cost}',
      methods: ['PUT', 'PATCH'],
      parameters: ['dayworks_cost'],
      bindings: { dayworks_cost: 'id' },
    },

    'api.v1.dayworks-costs.destroy': {
      uri: 'api/v1/dayworks-costs/{dayworks_cost}',
      methods: ['DELETE'],
      parameters: ['dayworks_cost'],
      bindings: { dayworks_cost: 'id' },
    },

    'api.v1.trade-item-costs.comments.update': {
      uri: 'api/v1/trade-item-costs/{trade_item_cost}/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['trade_item_cost', 'comment'],
      bindings: { trade_item_cost: 'id', comment: 'id' },
    },

    'api.v1.trade-item-costs.comments.destroy': {
      uri: 'api/v1/trade-item-costs/{trade_item_cost}/comments/{comment}',
      methods: ['DELETE'],
      parameters: ['trade_item_cost', 'comment'],
      bindings: { trade_item_cost: 'id', comment: 'id' },
    },

    'api.v1.trade-item-costs.update': {
      uri: 'api/v1/trade-item-costs/{trade_item_cost}',
      methods: ['PUT', 'PATCH'],
      parameters: ['trade_item_cost'],
      bindings: { trade_item_cost: 'id' },
    },

    'api.v1.trade-item-costs.destroy': {
      uri: 'api/v1/trade-item-costs/{trade_item_cost}',
      methods: ['DELETE'],
      parameters: ['trade_item_cost'],
      bindings: { trade_item_cost: 'id' },
    },

    'api.v1.lump-sum-costs.comments.update': {
      uri: 'api/v1/lump-sum-costs/{lump_sum_cost}/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['lump_sum_cost', 'comment'],
      bindings: { lump_sum_cost: 'id', comment: 'id' },
    },

    'api.v1.lump-sum-costs.comments.store': {
      uri: 'api/v1/lump-sum-costs/{lump_sum_cost}/comments',
      methods: ['POST'],
      parameters: ['lump_sum_cost'],
      bindings: { lump_sum_cost: 'id' },
    },

    'api.v1.lump-sum-costs.comments.destroy': {
      uri: 'api/v1/lump-sum-costs/{lump_sum_cost}/comments/{comment}',
      methods: ['DELETE'],
      parameters: ['lump_sum_cost', 'comment'],
      bindings: { lump_sum_cost: 'id', comment: 'id' },
    },

    'api.v1.lump-sum-costs.update': {
      uri: 'api/v1/lump-sum-costs/{lump_sum_cost}',
      methods: ['PUT', 'PATCH'],
      parameters: ['lump_sum_cost'],
      bindings: { lump_sum_cost: 'id' },
    },

    'api.v1.lump-sum-costs.destroy': {
      uri: 'api/v1/lump-sum-costs/{lump_sum_cost}',
      methods: ['DELETE'],
      parameters: ['lump_sum_cost'],
      bindings: { lump_sum_cost: 'id' },
    },

    'api.v1.rates-costs.comments.update': {
      uri: 'api/v1/rates-costs/{rates_cost}/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['rates_cost', 'comment'],
      bindings: { rates_cost: 'id', comment: 'id' },
    },

    'api.v1.rates-costs.comments.store': {
      uri: 'api/v1/rates-costs/{rates_cost}/comments',
      methods: ['POST'],
      parameters: ['rates_cost'],
      bindings: { rates_cost: 'id' },
    },

    'api.v1.rates-costs.comments.destroy': {
      uri: 'api/v1/rates-costs/{rates_cost}/comments/{comment}',
      methods: ['DELETE'],
      parameters: ['rates_cost', 'comment'],
      bindings: { rates_cost: 'id', comment: 'id' },
    },

    'api.v1.rates-costs.update': {
      uri: 'api/v1/rates-costs/{rates_cost}',
      methods: ['PUT', 'PATCH'],
      parameters: ['rates_cost'],
      bindings: { rates_cost: 'id' },
    },

    'api.v1.rates-costs.destroy': {
      uri: 'api/v1/rates-costs/{rates_cost}',
      methods: ['DELETE'],
      parameters: ['rates_cost'],
      bindings: { rates_cost: 'id' },
    },

    'api.v1.packages.show': {
      uri: 'api/v1/packages/{package}',
      methods: ['GET', 'HEAD'],
      parameters: ['package'],
      bindings: { package: 'id' },
    },

    'api.v1.packages.update': {
      uri: 'api/v1/packages/{package}',
      methods: ['PUT', 'PATCH'],
      parameters: ['package'],
      bindings: { package: 'id' },
    },

    'api.v1.packages.destroy': {
      uri: 'api/v1/packages/{package}',
      methods: ['DELETE'],
      parameters: ['package'],
      bindings: { package: 'id' },
    },

    'api.v1.package-trade-items.update': {
      uri: 'api/v1/package-trade-items/{package_trade_item}',
      methods: ['PUT', 'PATCH'],
      parameters: ['package_trade_item'],
      bindings: { package_trade_item: 'id' },
    },

    'api.v1.package-trade-items.destroy': {
      uri: 'api/v1/package-trade-items/{package_trade_item}',
      methods: ['DELETE'],
      parameters: ['package_trade_item'],
      bindings: { package_trade_item: 'id' },
    },

    'api.v1.scope-gaps.show': {
      uri: 'api/v1/scope-gaps/{scope_gap}',
      methods: ['GET', 'HEAD'],
      parameters: ['scope_gap'],
      bindings: { scope_gap: 'id' },
    },

    'api.v1.scope-gap-items.show': {
      uri: 'api/v1/scope-gap-items/{scope_gap_item}',
      methods: ['GET', 'HEAD'],
      parameters: ['scope_gap_item'],
    },

    'api.v1.scope-gap-items.update': {
      uri: 'api/v1/scope-gap-items/{scope_gap_item}',
      methods: ['PUT', 'PATCH'],
      parameters: ['scope_gap_item'],
      bindings: { scope_gap_item: 'id' },
    },

    'api.v1.scope-gap-categories.update': {
      uri: 'api/v1/scope-gap-categories/{scope_gap_category}',
      methods: ['PUT', 'PATCH'],
      parameters: ['scope_gap_category'],
      bindings: { scope_gap_category: 'id' },
    },

    'api.v1.scope-gap-categories.destroy': {
      uri: 'api/v1/scope-gap-categories/{scope_gap_category}',
      methods: ['DELETE'],
      parameters: ['scope_gap_category'],
      bindings: { scope_gap_category: 'id' },
    },

    'api.v1.scope-gap-categories.sort': {
      uri: 'api/v1/scope-gap-categories/{scope_gap_category}/sort',
      methods: ['PATCH'],
      parameters: ['scope_gap_category'],
      bindings: { scope_gap_category: 'id' },
    },

    'api.v1.variation-order-categories.update': {
      uri: 'api/v1/variation-order-categories/{variation_order_category}',
      methods: ['PUT', 'PATCH'],
      parameters: ['variation_order_category'],
      bindings: { variation_order_category: 'id' },
    },

    'api.v1.variation-order-categories.destroy': {
      uri: 'api/v1/variation-order-categories/{variation_order_category}',
      methods: ['DELETE'],
      parameters: ['variation_order_category'],
      bindings: { variation_order_category: 'id' },
    },

    'api.v1.variation-order-categories.sort': {
      uri: 'api/v1/variation-order-categories/{variation_order_category}/sort',
      methods: ['PATCH'],
      parameters: ['variation_order_category'],
      bindings: { variation_order_category: 'id' },
    },

    'api.v1.monthly-scope-gap-forecasts.update': {
      uri: 'api/v1/monthly-scope-gap-forecasts/{monthly_scope_gap_forecast}',
      methods: ['PUT', 'PATCH'],
      parameters: ['monthly_scope_gap_forecast'],
      bindings: { monthly_scope_gap_forecast: 'id' },
    },

    'api.v1.monthly-scope-gap-forecasts.destroy': {
      uri: 'api/v1/monthly-scope-gap-forecasts/{monthly_scope_gap_forecast}',
      methods: ['DELETE'],
      parameters: ['monthly_scope_gap_forecast'],
      bindings: { monthly_scope_gap_forecast: 'id' },
    },

    'api.v1.monthly-scope-gap-forecasts.sort': {
      uri: 'api/v1/monthly-scope-gap-forecasts/{monthly_scope_gap_forecast}/sort',
      methods: ['PATCH'],
      parameters: ['monthly_scope_gap_forecast'],
      bindings: { monthly_scope_gap_forecast: 'id' },
    },

    'api.v1.wbs-codes.update': {
      uri: 'api/v1/wbs-codes/{wbs_code}',
      methods: ['PUT', 'PATCH'],
      parameters: ['wbs_code'],
      bindings: { wbs_code: 'id' },
    },

    'api.v1.wbs-codes.destroy': {
      uri: 'api/v1/wbs-codes/{wbs_code}',
      methods: ['DELETE'],
      parameters: ['wbs_code'],
      bindings: { wbs_code: 'id' },
    },

    'api.v1.variation-orders.show': {
      uri: 'api/v1/variation-orders/{variation_order}',
      methods: ['GET', 'HEAD'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.update': {
      uri: 'api/v1/variation-orders/{variation_order}',
      methods: ['PUT', 'PATCH'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.destroy': {
      uri: 'api/v1/variation-orders/{variation_order}',
      methods: ['DELETE'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.notice.store': {
      uri: 'api/v1/variation-orders/{variation_order}/notice',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.pricing-notice.store': {
      uri: 'api/v1/variation-orders/{variation_order}/pricing-notice',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.next-action': {
      uri: 'api/v1/variation-orders/{variation_order}/next-action',
      methods: ['PATCH'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.forecast-amounts': {
      uri: 'api/v1/variation-orders/{variation_order}/forecast-amounts',
      methods: ['PATCH'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.baseline-forecast': {
      uri: 'api/v1/variation-orders/{variation_order}/baseline-forecast',
      methods: ['PATCH'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.accept': {
      uri: 'api/v1/variation-orders/{variation_order}/accept',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.decline': {
      uri: 'api/v1/variation-orders/{variation_order}/decline',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.pricing': {
      uri: 'api/v1/variation-orders/{variation_order}/pricing',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.reprice': {
      uri: 'api/v1/variation-orders/{variation_order}/reprice',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.submit': {
      uri: 'api/v1/variation-orders/{variation_order}/submit',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.approve-in-principle': {
      uri: 'api/v1/variation-orders/{variation_order}/approve-in-principle',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.approve': {
      uri: 'api/v1/variation-orders/{variation_order}/approve',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.complete': {
      uri: 'api/v1/variation-orders/{variation_order}/complete',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.comments': {
      uri: 'api/v1/variation-orders/{variation_order}/comments',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.send-notice': {
      uri: 'api/v1/variation-orders/{variation_order}/send-notice',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.media.store': {
      uri: 'api/v1/variation-orders/{variation_order}/media',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.media.show': {
      uri: 'api/v1/variation-orders/{variation_order}/media',
      methods: ['GET', 'HEAD'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.correspondence.index': {
      uri: 'api/v1/variation-orders/{variation_order}/correspondence',
      methods: ['GET', 'HEAD'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.correspondence.store': {
      uri: 'api/v1/variation-orders/{variation_order}/correspondence',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.correspondence.media.show': {
      uri: 'api/v1/correspondence/{correspondence}/media',
      methods: ['GET', 'HEAD'],
      parameters: ['correspondence'],
      bindings: { correspondence: 'id' },
    },

    'api.v1.quantities.update': {
      uri: 'api/v1/quantities/{quantity}',
      methods: ['PUT', 'PATCH'],
      parameters: ['quantity'],
      bindings: { quantity: 'id' },
    },

    'api.v1.quantities.destroy': {
      uri: 'api/v1/quantities/{quantity}',
      methods: ['DELETE'],
      parameters: ['quantity'],
      bindings: { quantity: 'id' },
    },

    'api.v1.surveyed.update': {
      uri: 'api/v1/quantities/surveyed/{surveyed}',
      methods: ['PUT', 'PATCH'],
      parameters: ['surveyed'],
      bindings: { surveyed: 'id' },
    },

    'api.v1.project-supplier.show': {
      uri: 'api/v1/project-supplier/{project_supplier}',
      methods: ['GET', 'HEAD'],
      parameters: ['project_supplier'],
      bindings: { project_supplier: 'id' },
    },

    'api.v1.project-supplier.update': {
      uri: 'api/v1/project-supplier/{project_supplier}',
      methods: ['PUT', 'PATCH'],
      parameters: ['project_supplier'],
      bindings: { project_supplier: 'id' },
    },

    'api.v1.project-supplier.destroy': {
      uri: 'api/v1/project-supplier/{project_supplier}',
      methods: ['DELETE'],
      parameters: ['project_supplier'],
      bindings: { project_supplier: 'id' },
    },

    'api.v1.asset-type.update': {
      uri: 'api/v1/asset-type/{asset_type}',
      methods: ['PUT', 'PATCH'],
      parameters: ['asset_type'],
      bindings: { asset_type: 'id' },
    },

    'api.v1.asset-type.destroy': {
      uri: 'api/v1/asset-type/{asset_type}',
      methods: ['DELETE'],
      parameters: ['asset_type'],
      bindings: { asset_type: 'id' },
    },

    'api.v1.plant-categories.update': {
      uri: 'api/v1/plant-categories/{plant_category}',
      methods: ['PUT', 'PATCH'],
      parameters: ['plant_category'],
      bindings: { plant_category: 'id' },
    },

    'api.v1.plant-categories.destroy': {
      uri: 'api/v1/plant-categories/{plant_category}',
      methods: ['DELETE'],
      parameters: ['plant_category'],
      bindings: { plant_category: 'id' },
    },

    'api.v1.claims.show': {
      uri: 'api/v1/claims/{claim}',
      methods: ['GET', 'HEAD'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.update': {
      uri: 'api/v1/claims/{claim}',
      methods: ['PUT', 'PATCH'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.destroy': {
      uri: 'api/v1/claims/{claim}',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.diary-entries.show': {
      uri: 'api/v1/diary-entries/{diary_entry}',
      methods: ['GET', 'HEAD'],
      parameters: ['diary_entry'],
      bindings: { diary_entry: 'id' },
    },

    'api.v1.diary-entries.update': {
      uri: 'api/v1/diary-entries/{diary_entry}',
      methods: ['PUT', 'PATCH'],
      parameters: ['diary_entry'],
      bindings: { diary_entry: 'id' },
    },

    'api.v1.claims.send.draft': {
      uri: 'api/v1/claims/{claim}/send',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.request-approval': {
      uri: 'api/v1/claims/{claim}/request-approval',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.resend-pqs': {
      uri: 'api/v1/claims/{claim}/resend-pqs',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.resend-contractor': {
      uri: 'api/v1/claims/{claim}/resend-contractor',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.store-media': {
      uri: 'api/v1/claims/{claim}/media',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.media': {
      uri: 'api/v1/claims/{claim}/media',
      methods: ['GET', 'HEAD'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.trades.update': {
      uri: 'api/v1/trades/{trade}',
      methods: ['PUT', 'PATCH'],
      parameters: ['trade'],
      bindings: { trade: 'id' },
    },

    'api.v1.trades.destroy': {
      uri: 'api/v1/trades/{trade}',
      methods: ['DELETE'],
      parameters: ['trade'],
      bindings: { trade: 'id' },
    },

    'api.v1.trades.comments.update': {
      uri: 'api/v1/trades/{trade}/comments/{comment}',
      methods: ['PATCH'],
      parameters: ['trade', 'comment'],
      bindings: { trade: 'id', comment: 'id' },
    },

    'api.v1.trades.sort': {
      uri: 'api/v1/trades/{trade}/sort',
      methods: ['PATCH'],
      parameters: ['trade'],
      bindings: { trade: 'id' },
    },

    'api.v1.trades.baseline-forecast': {
      uri: 'api/v1/trades/{trade}/baseline-forecast',
      methods: ['PATCH'],
      parameters: ['trade'],
      bindings: { trade: 'id' },
    },

    'api.v1.trades.forecast': {
      uri: 'api/v1/trades/{trade}/forecast',
      methods: ['PATCH'],
      parameters: ['trade'],
      bindings: { trade: 'id' },
    },

    'api.v1.trade-items.show': {
      uri: 'api/v1/trade-items/{trade_item}',
      methods: ['GET', 'HEAD'],
      parameters: ['trade_item'],
      bindings: { trade_item: 'id' },
    },

    'api.v1.trade-items.update': {
      uri: 'api/v1/trade-items/{trade_item}',
      methods: ['PUT', 'PATCH'],
      parameters: ['trade_item'],
      bindings: { trade_item: 'id' },
    },

    'api.v1.trade-items.destroy': {
      uri: 'api/v1/trade-items/{trade_item}',
      methods: ['DELETE'],
      parameters: ['trade_item'],
      bindings: { trade_item: 'id' },
    },

    'api.v1.trade-items.sort': {
      uri: 'api/v1/trade-items/{trade_item}/sort',
      methods: ['PATCH'],
      parameters: ['trade_item'],
      bindings: { trade_item: 'id' },
    },

    'api.v1.companies.index': { uri: 'api/v1/companies', methods: ['GET', 'HEAD'] },
    'api.v1.companies.update': {
      uri: 'api/v1/companies/{company}',
      methods: ['PUT', 'PATCH'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.suppliers.search': { uri: 'api/v1/search/suppliers', methods: ['GET', 'HEAD'] },
    'api.v1.delays.show': {
      uri: 'api/v1/delays/{delay}',
      methods: ['GET', 'HEAD'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.update': {
      uri: 'api/v1/delays/{delay}',
      methods: ['PUT', 'PATCH'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.destroy': {
      uri: 'api/v1/delays/{delay}',
      methods: ['DELETE'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.contract-events.show': {
      uri: 'api/v1/contract-events/{contract_event}',
      methods: ['GET', 'HEAD'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.update': {
      uri: 'api/v1/contract-events/{contract_event}',
      methods: ['PUT', 'PATCH'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.destroy': {
      uri: 'api/v1/contract-events/{contract_event}',
      methods: ['DELETE'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.purchase-orders.show': {
      uri: 'api/v1/purchase-orders/{purchase_order}',
      methods: ['GET', 'HEAD'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.update': {
      uri: 'api/v1/purchase-orders/{purchase_order}',
      methods: ['PUT', 'PATCH'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.destroy': {
      uri: 'api/v1/purchase-orders/{purchase_order}',
      methods: ['DELETE'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.mark-paid': {
      uri: 'api/v1/purchase-orders/{purchase_order}/mark-paid',
      methods: ['POST'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.cancel': {
      uri: 'api/v1/purchase-orders/{purchase_order}/cancel',
      methods: ['POST'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.media.store': {
      uri: 'api/v1/purchase-orders/{purchase_order}/media',
      methods: ['POST'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.media.show': {
      uri: 'api/v1/purchase-orders/{purchase_order}/media',
      methods: ['GET', 'HEAD'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.purchase-orders.comments': {
      uri: 'api/v1/purchase-orders/{purchase_order}/comments',
      methods: ['POST'],
      parameters: ['purchase_order'],
      bindings: { purchase_order: 'id' },
    },

    'api.v1.contract-events.register-variation-order': {
      uri: 'api/v1/contract-events/{contract_event}/register-variation-order',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.register-delay': {
      uri: 'api/v1/contract-events/{contract_event}/register-delay',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.register-variation-order-and-delay': {
      uri: 'api/v1/contract-events/{contract_event}/register-variation-order-and-delay',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.decline': {
      uri: 'api/v1/contract-events/{contract_event}/decline',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.media.store': {
      uri: 'api/v1/contract-events/{contract_event}/media',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.media.show': {
      uri: 'api/v1/contract-events/{contract_event}/media',
      methods: ['GET', 'HEAD'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.next-action': {
      uri: 'api/v1/contract-events/{contract_event}/next-action',
      methods: ['PATCH'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.save-next-action': {
      uri: 'api/v1/contract-events/{contract_event}/save-next-action',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.contract-events.comments': {
      uri: 'api/v1/contract-events/{contract_event}/comments',
      methods: ['POST'],
      parameters: ['contract_event'],
      bindings: { contract_event: 'id' },
    },

    'api.v1.delays.accept': {
      uri: 'api/v1/delays/{delay}/accept',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.decline': {
      uri: 'api/v1/delays/{delay}/decline',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.submit': {
      uri: 'api/v1/delays/{delay}/submit',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.approve': {
      uri: 'api/v1/delays/{delay}/approve',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.comments': {
      uri: 'api/v1/delays/{delay}/comments',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.send-notice': {
      uri: 'api/v1/delays/{delay}/send-notice',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.complete': {
      uri: 'api/v1/delays/{delay}/complete',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.attach-variation-order': {
      uri: 'api/v1/delays/{delay}/variation-orders/attach',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.media.show': {
      uri: 'api/v1/delays/{delay}/media',
      methods: ['GET', 'HEAD'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.media.store': {
      uri: 'api/v1/delays/{delay}/media',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.notice.store': {
      uri: 'api/v1/delays/{delay}/notice',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.value-notice.store': {
      uri: 'api/v1/delays/{delay}/value-notice',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.correspondence.index': {
      uri: 'api/v1/delays/{delay}/correspondence',
      methods: ['GET', 'HEAD'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.correspondence.store': {
      uri: 'api/v1/delays/{delay}/correspondence',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.package-trade-items.wbs-code': {
      uri: 'api/v1/packages/{package}/package-trade-items/wbs-code',
      methods: ['POST'],
      parameters: ['package'],
      bindings: { package: 'id' },
    },

    'api.v1.package-trade-items.forecast-amounts': {
      uri: 'api/v1/package-trade-items/{package_trade_item}/forecast-amounts',
      methods: ['PATCH'],
      parameters: ['package_trade_item'],
      bindings: { package_trade_item: 'id' },
    },

    'api.v1.delays.next-action': {
      uri: 'api/v1/delays/{delay}/next-action',
      methods: ['PATCH'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.admin.report-sections.index': { uri: 'api/v1/admin/report-sections', methods: ['GET', 'HEAD'] },
    'api.v1.admin.report-sections.show': {
      uri: 'api/v1/admin/report-sections/{report_section}',
      methods: ['GET', 'HEAD'],
      parameters: ['report_section'],
      bindings: { report_section: 'id' },
    },

    'api.v1.admin.report-sections.seed': { uri: 'api/v1/admin/report-sections/seed', methods: ['POST'] },
    'api.v1.admin.projects.index': { uri: 'api/v1/admin/projects', methods: ['GET', 'HEAD'] },
    'api.v1.admin.projects.seed-demo': { uri: 'api/v1/admin/projects/seed-demo', methods: ['POST'] },
    'api.v1.admin.projects.update': {
      uri: 'api/v1/admin/projects/{project}',
      methods: ['PATCH'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.admin.projects.search': { uri: 'api/v1/admin/projects/search', methods: ['GET', 'HEAD'] },
    'api.v1.admin.users.index': { uri: 'api/v1/admin/users', methods: ['GET', 'HEAD'] },
    'api.v1.admin.users.welcome-email': {
      uri: 'api/v1/admin/users/{user}/welcome',
      methods: ['POST'],
      parameters: ['user'],
      bindings: { user: 'id' },
    },
    'api.v1.admin.users.tokens.index': {
      uri: 'api/v1/admin/users/{user}/tokens',
      methods: ['GET', 'HEAD'],
      parameters: ['user'],
      bindings: { user: 'id' },
    },
    'api.v1.admin.users.tokens.destroy': {
      uri: 'api/v1/admin/users/{user}/tokens/{token}',
      methods: ['DELETE'],
      parameters: ['user', 'token'],
      bindings: { user: 'id' },
    },


    'api.v1.admin.projects.restore': {
      uri: 'api/v1/admin/projects/{project}/restore',
      methods: ['PATCH'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.admin.projects.force-delete': {
      uri: 'api/v1/admin/projects/{project}/force-delete',
      methods: ['DELETE'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.admin.companies.index': { uri: 'api/v1/admin/companies', methods: ['GET', 'HEAD'] },
    'api.v1.admin.companies.store': { uri: 'api/v1/admin/companies', methods: ['POST'] },
    'api.v1.admin.companies.show': {
      uri: 'api/v1/admin/companies/{company}',
      methods: ['GET', 'HEAD'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.admin.companies.update': {
      uri: 'api/v1/admin/companies/{company}',
      methods: ['PUT', 'PATCH'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.admin.companies.destroy': {
      uri: 'api/v1/admin/companies/{company}',
      methods: ['DELETE'],
      parameters: ['company'],
      bindings: { company: 'id' },
    },

    'api.v1.admin.claims.index': { uri: 'api/v1/admin/claims', methods: ['GET', 'HEAD'] },
    'api.v1.admin.claims.show': {
      uri: 'api/v1/admin/claims/{claim}',
      methods: ['GET', 'HEAD'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.admin.claims.update': {
      uri: 'api/v1/admin/claims/{claim}',
      methods: ['PUT', 'PATCH'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.admin.claims.destroy': {
      uri: 'api/v1/admin/claims/{claim}',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.admin.variation-orders.index': { uri: 'api/v1/admin/variation-orders', methods: ['GET', 'HEAD'] },
    'api.v1.admin.variation-orders.show': {
      uri: 'api/v1/admin/variation-orders/{variation_order}',
      methods: ['GET', 'HEAD'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.admin.variation-orders.update': {
      uri: 'api/v1/admin/variation-orders/{variation_order}',
      methods: ['PUT', 'PATCH'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.admin.variation-orders.destroy': {
      uri: 'api/v1/admin/variation-orders/{variation_order}',
      methods: ['DELETE'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.media.show': {
      uri: 'api/v1/media/{media}',
      methods: ['GET', 'HEAD'],
      parameters: ['media'],
      bindings: { media: 'uuid' },
    },

    'api.v1.media.download': {
      uri: 'api/v1/media/{media}/download',
      methods: ['GET', 'HEAD'],
      parameters: ['media'],
      bindings: { media: 'uuid' },
    },

    'api.v1.media.destroy': {
      uri: 'api/v1/media/{media}',
      methods: ['DELETE'],
      parameters: ['media'],
      bindings: { media: 'uuid' },
    },

    'api.v1.media.settings.update': {
      uri: 'api/v1/media/{media}/settings/update',
      methods: ['PATCH'],
      parameters: ['media'],
      bindings: { media: 'uuid' },
    },

    'api.v1.claims.certified.store': {
      uri: 'api/v1/claims/{claim}/certified',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.claim.store': {
      uri: 'api/v1/claims/{claim}/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.submit': {
      uri: 'api/v1/claims/{claim}/subcontractor/submit',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.sopa-disclaimer.update': {
      uri: 'api/v1/claims/{claim}/subcontractor/sopa-disclaimer',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.media.store': {
      uri: 'api/v1/claims/{claim}/subcontractor/media',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.media': {
      uri: 'api/v1/claims/{claim}/subcontractor/media',
      methods: ['GET', 'HEAD'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.media.destroy': {
      uri: 'api/v1/claims/{claim}/subcontractor/media',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.lump-sum.claim.store': {
      uri: 'api/v1/claims/{claim}/lump-sum/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.lump-sum.claim.destroy': {
      uri: 'api/v1/claims/{claim}/lump-sum/claim',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.rates.claim.store': {
      uri: 'api/v1/claims/{claim}/rates/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.rates.claim.destroy': {
      uri: 'api/v1/claims/{claim}/rates/claim',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.variation.claim.store': {
      uri: 'api/v1/claims/{claim}/subcontractor/variation-order/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.variation.claim.destroy': {
      uri: 'api/v1/claims/{claim}/subcontractor/variation-order/claim',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.claim.store': {
      uri: 'api/v1/claims/{claim}/subcontractor/dayworks/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.claim.destroy': {
      uri: 'api/v1/claims/{claim}/subcontractor/dayworks/claim',
      methods: ['DELETE'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.variation.claim.store': {
      uri: 'api/v1/claims/{claim}/variation-order/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.variation.certified.store': {
      uri: 'api/v1/claims/{claim}/variation-order/certified',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.shared-fund.claim.store': {
      uri: 'api/v1/claims/{claim}/shared-fund/claim',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.shared-fund.certified.store': {
      uri: 'api/v1/claims/{claim}/shared-fund/certified',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.trade-item-costs.comments.update.signed': {
      uri: 'api/v1/claims/{claim}/trade-item-costs/comments',
      methods: ['PATCH'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.trade-item-costs.comments.store.signed': {
      uri: 'api/v1/claims/{claim}/trade-item-costs/comments',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.variation-order-costs.comments.update.signed': {
      uri: 'api/v1/claims/{claim}/variation-order-costs/comments',
      methods: ['PATCH'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.variation-order-costs.comments.store.signed': {
      uri: 'api/v1/claims/{claim}/variation-order-costs/comments',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.shared-fund-costs.comments.update.signed': {
      uri: 'api/v1/claims/{claim}/shared-fund-costs/comments',
      methods: ['PATCH'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.shared-fund-costs.comments.store.signed': {
      uri: 'api/v1/claims/{claim}/shared-fund-costs/comments',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.labour.records.guest': {
      uri: 'api/v1/claims/{claim}/subcontractor/dayworks/labour/records',
      methods: ['GET', 'HEAD'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.claims.dayworks.plant.records.guest': {
      uri: 'api/v1/claims/{claim}/subcontractor/dayworks/plant/records',
      methods: ['GET', 'HEAD'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.subcontractor.tenders.items.store': {
      uri: 'api/v1/tenders/{tender}/items',
      methods: ['POST'],
      parameters: ['tender'],
      bindings: { tender: 'id' },
    },

    'api.v1.subcontractor.tenders.submit': {
      uri: 'api/v1/tenders/{tender}/submit',
      methods: ['POST'],
      parameters: ['tender'],
      bindings: { tender: 'id' },
    },

    'api.v1.claims.send.pqs': {
      uri: 'api/claims/{claim}/send/pqs',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.send.contractor': {
      uri: 'api/claims/{claim}/send/contractor',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.claims.certify': {
      uri: 'api/claims/{claim}/send/certify',
      methods: ['POST'],
      parameters: ['claim'],
      bindings: { claim: 'id' },
    },

    'api.v1.variation-orders.provision': {
      uri: 'api/variation-orders/{variation_order}/provision',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.variation-orders.decline-submission': {
      uri: 'api/variation-orders/{variation_order}/decline-submission',
      methods: ['POST'],
      parameters: ['variation_order'],
      bindings: { variation_order: 'id' },
    },

    'api.v1.delays.decline-submission': {
      uri: 'api/delays/{delay}/decline-submission',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.delays.provision': {
      uri: 'api/delays/{delay}/provision',
      methods: ['POST'],
      parameters: ['delay'],
      bindings: { delay: 'id' },
    },

    'api.v1.me': { uri: 'api/v1/user', methods: ['GET', 'HEAD'] },
    'api.v1.projects.export': {
      uri: 'exports/{project}/tracker',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.cost-at-complete-export': {
      uri: 'exports/{project}/cost-at-complete',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.quantities.export': {
      uri: 'exports/{project}/quantities',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },

    'api.v1.subcontractor.packages.export': {
      uri: 'exports/{project}/subcontractor-packages',
      methods: ['GET', 'HEAD'],
      parameters: ['project'],
      bindings: { project: 'id' },
    },
  },
} as const;

export { Ziggy };
